import type { ReactNode } from 'react';

import { cn } from '@shared/lib/cn';

import { GRADE_BG_CLASS, SERIES_BG_CLASS } from './chart.constant';
import type { ChartColorKey } from './model/dataviz.types';

export type ChartLegendDotProps = ChartColorKey & {
  /** Figma `Show label` + `Label` — 계열 이름. 없으면 점만 그린다 */
  children?: ReactNode;
  className?: string;
};

/** 그래프 범례의 한 항목: 색 점(지름 10) + 계열 이름(12). 모든 범례 · 말풍선 색 점에 쓴다 */
export function ChartLegendDot({ kind, step, children, className }: ChartLegendDotProps) {
  const dotClass = kind === 'series' ? SERIES_BG_CLASS[step] : GRADE_BG_CLASS[`${step}`];
  const hasLabel = children !== undefined && children !== null && children !== false;
  return (
    <span
      data-kind={kind}
      data-step={step}
      className={cn('inline-flex shrink-0 items-center gap-1', hasLabel && 'h-4', className)}
    >
      <span aria-hidden className={cn('size-2-5 shrink-0 rounded-full', dotClass)} />
      {hasLabel ? (
        <span className="whitespace-nowrap text-dataviz-legend typo-caption">{children}</span>
      ) : null}
    </span>
  );
}
